import {computed, defineComponent} from 'vue';
import {useIsMobile} from '@/app/shared/composables/useIsMobile';
import {escape} from 'html-escaper';

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlContactCard',
    props: {
        title: {
            type: String, required: true,
        },
        subtitle: {
            type: String, required: false, default: undefined,
        },
        titleTag: {
            type: String, required: false, default: 'span',
        },
        address: {
            type: String, required: false, default: undefined,
        },
        phone: {
            type: String, required: false, default: undefined,
        },
        email: {
            type: String, required: false, default: undefined,
        },
        modEmailClickable: {
            type: Boolean, required: false, default: false,
        },
        modContactClickable :{
            type: Boolean, required: false, default: false,
        },
        emailLink: {
            type: String, required: false, default: undefined,
        },
        message: {
            type: String, required: false, default: undefined,
        },
        emergencyPhone: {
            type: String, required: false, default: undefined,
        },
        emergencyEmail: {
            type: String, required: false, default: undefined,
        },
    },
    setup(props) {
        const isMobile = useIsMobile();

        const isPhoneClickable = computed(() => {
            return isMobile.value;
        });

        const cleanedAddress = computed(() => {
            const trimmed = props.address?.trim();
            if (trimmed === '<br>') return '';
            return trimmed;
        });

        const sanitizedTitle = computed(() => {
            return props.title ? escape(props.title) : '';
        });

        const sanitizedSubtitle = computed(() => {
            return props.subtitle ? escape(props.subtitle) : undefined;
        });

        const sanitizedMessage = computed(() => {
            return props.message ? escape(props.message) : undefined;
        });

        return {
            sanitizedTitle,
            sanitizedSubtitle,
            sanitizedMessage,
            cleanedAddress,
            isPhoneClickable
        }
    }
})
